/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import Navigation from './Navigation';
import ThemeToggle from '../../shared/theme-toggle';
import { AdminGuard, PartnerGuard } from '../../guards/RolesGuard';
import { useTheme } from '../../utils/theme-context';
import Cookies from 'js-cookie';
import DownloadReviews from './DownloadReviews';

interface ISidebar {
  onClickShowModal: () => void;
  onClickOpenChat: (id?: string, action?: any) => void;
  isMobile?: boolean
}

const Sidebar = ({
  onClickShowModal,
  onClickOpenChat,
  isMobile = false
}: ISidebar) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [userInfoData, setUserInfoData] = useState<any>();
  const { data: userInfo } = useGetCurrentUserQuery();
  const [search, setSearch] = useState<string>();

  const handleLogout = () => {
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
    Cookies.remove('roles');
    Cookies.remove('user');
    window.location.reload();
    // (window as any).Intercom('shutdown');
    navigate('/login');
  }

  const onChangePageSearch = (value: string) => {
    setSearch(value)
  }

  const isJsonObject = (jsonString: string) => {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === 'object') {
        return true;
      }
    }
    catch (e) { }
    return false;
  };

  const getCurrentUserData = async () => {
    const getUserLocal: any = Cookies.get('user') || null;
    const userFormat: any = isJsonObject(getUserLocal) ? JSON.parse(getUserLocal) : undefined
    if (getUserLocal && (!userFormat && !userFormat?.username)) {
      setUserInfoData(getUserLocal)
    } else {
      setUserInfoData(userInfo?.data?.username)
      // localStorage.setItem('user', userInfo?.username || '');
      Cookies.set('user', userInfo?.data?.username, {
        path: '/',
        secure: true,
        sameSite: 'None',
      });
      Cookies.set('roles', userInfo?.data?.type, {
        path: '/',
        secure: true,
        sameSite: 'None',
      });
    }
  }

  useEffect(() => {
    if (!userInfoData) {
      getCurrentUserData()
    }
  }, [userInfo])

  return (
    <div className={`${isMobile ? 'w-64 h-full flex flex-col bg-white dark:bg-bgColor-darkMode' : 'hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 border-r-1 border-r dark:border-borderColor-darkMode dark:bg-bgColor-darkMode'}`}>
      <div className='flex flex-row items-center gap-3 mb-6 mt-4 px-3 sm:px-4'>
        <img
          className='w-[28px] h-[28px] sm:w-11 sm:h-11 border border-1 border-[#00330F] p-1  dark:bg-white rounded-full flex-shrink-0'
          src='/svg/default_picture.svg'
          alt='main photo'
        />
        <div className='text-left min-w-0 flex-1'>
          <div title={userInfoData} className='text-[14px] font-medium font-inter text-[#252B37] dark:text-primary-darkMode truncate' style={{ fontFamily: '"Plus Jakarta Sans", Inter, sans-serif', letterSpacing: '-0.02em' }}>
            {userInfoData}
          </div>
          <p className='text-[12px] text-[#717680] dark:text-primary-darkMode mt-0.5' style={{ fontFamily: '"Plus Jakarta Sans", Inter, sans-serif', letterSpacing: '-0.02em' }}>{AdminGuard() ? 'Administrator' : 'Member'}</p>
        </div>
        <div className='flex flex-row items-center gap-1.5 flex-shrink-0'>
          <div className='cursor-pointer hover:opacity-80' onClick={() => navigate('/settings')}>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/settings-icon-white.svg' : '/assets/navigation-icons/sidebar/settings-icon.svg'}
              className='object-contain w-5 h-5'
            />
          </div>
          <div className='cursor-pointer hover:opacity-80' onClick={handleLogout}>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/logout-icon-white.svg' : '/assets/navigation-icons/sidebar/logout-icon.svg'}
              className='object-contain w-5 h-5'
            />
          </div>
        </div>
      </div>
      <div className='border-b py-3 px-3 sm:px-4 dark:border-white/10'>
        {/* <DownloadReviews /> */}
        {!PartnerGuard() &&
          <div
            onClick={() => onClickOpenChat(undefined, undefined)}
            className='flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/new-question-white.svg' : '/assets/navigation-icons/sidebar/new-question.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3'
            />
            <p className='text-sm sm:text-base dark:text-primary-darkMode'>Manage Users</p>
          </div>
        }
        {/* <div
          onClick={onClickShowModal}
          className='flex flex-row !rounded-lg bg-[#FAFAFA] dark:bg-black items-center justify-between p-2 cursor-pointer hover:opacity-80'
        >
          <div className='flex flex-row items-center'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/search-icon-white.svg' : '/assets/navigation-icons/sidebar/search-icon.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3'
            />
            <p className='text-sm sm:text-base text-primary-light'>Search chats...</p>
          </div>
          <img
            src={theme === 'dark' ? '/assets/navigation-icons/sidebar/text-icon-white.svg' : '/assets/navigation-icons/sidebar/text-icon.svg'}
            className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]'
          />
        </div> */}
      </div>

      <div className='flex flex-col flex-grow pt-2 overflow-y-auto'>
        <nav data-qa='navigation' className='flex-1 px-3 sm:px-4 pb-4'>
          <Navigation search={search} />
        </nav>
      </div>

      <div className='border-t px-3 py-3 dark:border-white/10'>
        {/* <div className='!rounded-lg bg-[#F5F5F5] dark:bg-black border border-[#e9eaeb] p-3 cursor-pointer hover:opacity-80 '>
          <div className='flex flex-row items-center mb-2'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/add-icon-white.svg' : '/assets/navigation-icons/sidebar/add-icon.svg'}
              className='object-contain w-6 h-6 sm:w-[20px] sm:h-[20px] mr-2'
            />
            <p className='font-semibold text-sm dark:text-primary-darkMode sm:text-base'>Add agent</p>
          </div>
          <p className='text-xs sm:text-sm dark:text-primary-darkMode'>Find more about our upcoming agents and deals.</p>
        </div> */}

        <div className='my-4 sm:my-5'>
          <ThemeToggle />
        </div>

        <img
          src={theme === 'dark' ? '/assets/navigation-icons/sidebar/sidebar-icon-white.svg' : '/assets/navigation-icons/sidebar/sidebar-icon.svg'}
          className='object-contain h-10 sm:h-[45px] my-2'
        />
      </div>

    </div>
  )
}

export default Sidebar;